import React, { Component, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { commonActions, contracterActions, efdocActions, modalActions, alertActions } from '../../../../store/actions'

import EfDocumentList from './EfDocumentList'
import Calendar from '../../../../module/component-box/Calendar'
import queryString from 'query-string'
import Pagination from '../../../../module/pagination-box'
import history from '../../../../route/history'
import Loading from '../../../../module/loading/Loading'

const EfDocument = (props) => {
  const [state, setState] = useState({})
  const [searchWord, setSearchWord] = useState('')
  const [tempFrom, setTempFrom] = useState('')
  const [tempTo, setTempTo] = useState('')
  const [searchInfo, setSearchInfo] = useState([])
  const [pagingInfo, setPagingInfo] = useState({})
  const [tabId, setTabId] = useState('')

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    props.common({ mainCd: ['CRT_STS_CD', 'CRT_DV', 'ISSU_INST_CD'] })
    const query = queryString.parse(history.location.search)

    selectDay('Y1')
    
    if (Object.keys(query).length > 0) {
      props.settingHistory(query)
      setSearchInfo([
        { type: 'tabStatus', value: query.tabStatus },
        { type: 'searchWord', value: query.searchWord },
        { type: 'srhFrom', value: query.srhFrom },
        { type: 'srhTo', value: query.srhTo },
        { type: 'srhOrder', value: query.srhOrder },
        { type: 'srhBy', value: query.srhBy },
      ])
      if (query.searchWord) {
        setSearchWord(query.searchWord)
      }
    } else {
      searchList(searchInfo)
    }
    return () => {
      props.changeSearchInfo(null) // 이전 검색 초기화
    }
  }, [])

  // 검색조건 단건 변경시
  useEffect(() => {
    if (props.soloSelectInfo === null || props.soloSelectInfo === undefined) return
    //console.log('props.soloSelectInfo = ', props.soloSelectInfo);
    let arr = searchInfo?.filter((info) => info.type !== props.soloSelectInfo?.type)

    arr.push(props.soloSelectInfo)
    setSearchInfo(arr)
    searchList(arr)
  }, [props.soloSelectInfo])

  useEffect(() => {
    if (props.commoncode.length < 1) return
  }, [props.commoncode])

  useEffect(() => {
    const tRs = props.efdocList?.totalElements ? props.efdocList?.totalElements : 0
    const tPage = Math.ceil(tRs / 10)
    setPagingInfo({
      totalRecords: props.efdocList?.totalElements ? props.efdocList?.totalElements : 0,
      currentPage: state.pageIdx ? parseInt(state.pageIdx) + 1 : 1,
      pageNumber: props.efdocList?.pageable?.pageNumber,
      totalPage: tPage,
      pagesToShow: 10,
    })
    if (props.efdocList) {
      setLoading(false)
    }
  }, [props.efdocList])

  useEffect(() => {
    if (!props.history) return

    const idx = props.history?.pageIdx ? props.history?.pageIdx : 0

    searchList(null, idx)
  }, [props.history])

  const onSelected = (e, type, value) => {
    if (type === 'tabStatus') {
      return props.changeSearchInfo({ type, value })
    } else if (type === 'srhOrder') {
      return props.changeSearchInfo({ type, value })
    } else if (type === 'srhFrom') {
      setSearchInfo([
        { type: 'tabStatus', value: searchInfo.find((s) => s.type === 'tabStatus')?.value || '' },
        { type: 'srhKind', value: searchInfo.find((s) => s.type === 'srhKind')?.value || '' },
        { type: 'srhPrchsNm', value: searchInfo.find((s) => s.type === 'srhPrchsNm')?.value || '' },
        { type: 'searchWord', value: searchInfo.find((s) => s.type === 'searchWord')?.value || '' },
        { type: 'srhFrom', value: value },
        { type: 'srhTo', value: searchInfo.find((s) => s.type === 'srhTo')?.value || '' },
        { type: 'srhOrder', value: searchInfo.find((s) => s.type === 'srhOrder')?.value || '' },
        { type: 'srhBy', value: searchInfo.find((s) => s.type === 'srhBy')?.value || ''  },
      ])
      setTempFrom(value)
    } else if (type === 'srhTo') {
      setSearchInfo([
        { type: 'tabStatus', value: searchInfo.find((s) => s.type === 'tabStatus')?.value || '' },
        { type: 'srhKind', value: searchInfo.find((s) => s.type === 'srhKind')?.value || '' },
        { type: 'srhPrchsNm', value: searchInfo.find((s) => s.type === 'srhPrchsNm')?.value || '' },
        { type: 'searchWord', value: searchInfo.find((s) => s.type === 'searchWord')?.value || '' },
        { type: 'srhFrom', value: searchInfo.find((s) => s.type === 'srhFrom')?.value || '' },
        { type: 'srhTo', value: value },
        { type: 'srhOrder', value: searchInfo.find((s) => s.type === 'srhOrder')?.value || '' },
        { type: 'srhBy', value: searchInfo.find((s) => s.type === 'srhBy')?.value || ''  },
      ])
      setTempTo(value)
    }

    if (type !== 'searchWord') {
      setSearchInfo(
        searchInfo?.map((info) =>
          info.type === type
            ? {
                type,
                value: moment(value).format('Y-MM-DD'),
              }
            : info,
        ),
      )
    } else {
      if (
        (searchInfo.find((s) => s.type === 'srhFrom')?.value !== '' && searchInfo.find((s) => s.type === 'srhTo')?.value !== '') ||
        (searchInfo.find((s) => s.type === 'srhFrom')?.value !== 'undefined' &&
          searchInfo.find((s) => s.type === 'srhTo')?.value !== 'undefined')
      ) {
        if (searchInfo.find((s) => s.type === 'srhFrom')?.value > searchInfo.find((s) => s.type === 'srhTo')?.value) {
          return props.error({ message: '기간설정을 다시 입력해주세요.' })
        } else if (tempFrom > tempTo) {
          return props.error({ message: '기간설정을 다시 입력해주세요.' })
        } else {
          if (type === 'searchWord') {
            return props.changeSearchInfo({ type, value })
          } else {
            searchList(searchInfo)
          }
        }
      } else {
        if (type === 'searchWord') {
          return props.changeSearchInfo({ type, value })
        } else {
          searchList(searchInfo)
        }
      }
    }
  }

  const searchList = (searchInfo, index = 0) => {
    let sendSearch = {}

    if (searchInfo === null) {
      // history 남아있을시
      sendSearch = {
        srhFrom: props.history?.srhFrom,
        srhTo: props.history?.srhTo,
        tabStatus: props.history?.tabStatus ? props.history?.tabStatus : '99',
        srhOrder: props.history?.srhOrder ? props.history?.srhOrder : '',
        srhBy: props.history?.srhBy ? props.history?.srhBy : 'desc',
        searchWord: props.history?.searchWord ? props.history?.searchWord : '',
      }
    } else {
      sendSearch = {
        srhFrom: searchInfo?.find((s) => s.type === 'srhFrom')?.value || '',
        srhTo: searchInfo?.find((s) => s.type === 'srhTo')?.value || '',
        tabStatus: searchInfo?.find((s) => s.type === 'tabStatus')?.value || '',
        srhOrder: searchInfo?.find((s) => s.type === 'srhOrder')?.value || '',
        srhBy: searchInfo?.find((s) => s.type === 'srhBy')?.value || '',
        searchWord: searchInfo?.find((s) => s.type === 'searchWord')?.value || '',
      }
    }

    sendSearch.pageIdx = index

    setState({
      ...state,
      ...sendSearch,
    })

    if (searchInfo?.find((s) => s.type === 'srhFrom')?.value > searchInfo?.find((s) => s.type === 'srhTo')?.value) {
      return props.error({ message: '기간설정을 다시 입력해주세요.' })
    }

    let paramStr = queryString.stringify(sendSearch)
    //console.log('paramStr = ', paramStr);
    paramStr.length > 0 && (paramStr = '?' + paramStr)
    history.push('/service/offical/EfDocument' + paramStr)

    setLoading(true)
    props.readEfDocList(sendSearch)
  }

  const onCertboxDetail = (certbox) => {
    const status = certbox.sts

    props.selectCertboxInfo(certbox) // 선택한 대상의 정보 셋팅

    if (status === '01') {
      // 임시저장 - 발급화면 호출
      window.location.href = '/service/certapply/1?seq=' + certbox.crtRcvSeq
    } else if (status === '02' || status === '04') {
      // 전송완료,오류통보 - 발급화면 readonly상태로 호출
      history.push({ pathname: '/service/certapply/detail/' + certbox.crtRcvSeq, state: state })
    } else if (status === '03' || status === '10' || status === '11' || status === '12') {
      // 발급완료, 제출완료, 수취완료, 반려 - 상세조회화면 조회로 호출
      history.push({ pathname: '/service/certbox/detail/' + certbox.crtRcvSeq, state: state })
    }
  }

  const onCertboxSubmit = (checkedObjs, Objs) => {
    props.showModalBagic(checkedObjs, Objs)
  }

  const handleKeyPress = (e) => {
    const { name, value } = e.target
    if (e.key === 'Enter') {
      onSelected(e, name, value)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    onSelected(e, name, value)
  }

  const selectDay = (type) => {
    const d = new Date()
    const year = d.getFullYear() // 년
    const month = d.getMonth() // 월
    const day = d.getDate() // 일

    let tdt = new Date(year, month, day)
    tdt = moment(tdt).format('Y-MM-DD')
    if (type === 'W1') {
      // 1주일
      let fdt = new Date(year, month, day - 7)
      fdt = moment(fdt).format('Y-MM-DD')
      let arr = []
      arr.push({ type: 'srhFrom', value: fdt })
      arr.push({ type: 'srhTo', value: tdt })

      setTempFrom(fdt)
      setTempTo(tdt)
      setSearchInfo(arr)
      searchList(arr)
    } else if (type === 'M1') {
      // 1개월
      let fdt = new Date(year, month - 1, day)
      fdt = moment(fdt).format('Y-MM-DD')
      let arr = []
      arr.push({ type: 'srhFrom', value: fdt })
      arr.push({ type: 'srhTo', value: tdt })

      setTempFrom(fdt)
      setTempTo(tdt)
      setSearchInfo(arr)
      searchList(arr)
    } else if (type === 'M3') {
      // 3개월
      let fdt = new Date(year, month - 3, day)
      fdt = moment(fdt).format('Y-MM-DD')
      let arr = []
      arr.push({ type: 'srhFrom', value: fdt })
      arr.push({ type: 'srhTo', value: tdt })

      setTempFrom(fdt)
      setTempTo(tdt)
      setSearchInfo(arr)
      searchList(arr)
    } else if (type === 'M6') {
      // 6개월
      let fdt = new Date(year, month - 6, day)
      fdt = moment(fdt).format('Y-MM-DD')
      let arr = []
      arr.push({ type: 'srhFrom', value: fdt })
      arr.push({ type: 'srhTo', value: tdt })

      setTempFrom(fdt)
      setTempTo(tdt)
      setSearchInfo(arr)
      searchList(arr)
    } else if (type === 'Y1') {
      // 1년
      let fdt = new Date(year - 1, month, day)
      fdt = moment(fdt).format('Y-MM-DD')
      let arr = []
      arr.push({ type: 'srhFrom', value: fdt })
      arr.push({ type: 'srhTo', value: tdt })

      setTempFrom(fdt)
      setTempTo(tdt)
      setSearchInfo(arr)
      searchList(arr)
    } else {
      let arr = []
      arr.push({ type: 'srhFrom', value: '' })
      arr.push({ type: 'srhTo', value: '' })

      setTempFrom(null)
      setTempTo(null)
      setSearchInfo(arr)
      searchList(arr)
    }
  }

  return (
    <>
      {/* contents */}
      {loading ? <Loading /> : null}
      <div id="contents">
        <div className="content-header">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault()
              window.history.back()
            }}
            className="page-prev"
          >
            뒤로이동
          </a>
          {/* mobile */}
          <h2>공인전자문서</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>전자문서지갑</span>
            <em>공인전자문서</em>
          </div>
        </div>

        <div className="search-box">
          <div className="row">
            <span className="tit">기간</span>
            <span className="datepicker">
              <Calendar
                onSelect={(value) => onSelected(null, 'srhFrom', value ? moment(value).format('Y-MM-DD') : '')}
                // default={searchInfo?.find((i) => i.type === 'srhFrom')?.value}
                default={tempFrom}
                title="처음날짜(발급일)"
              />
              <span className="split">~</span>
              <Calendar
                onSelect={(value) => onSelected(null, 'srhTo', value ? moment(value).format('Y-MM-DD') : '')}
                // default={searchInfo?.find((i) => i.type === 'srhTo')?.value}
                default={tempTo}
                title="마지막날짜(발급일)"
              />
            </span>
            <span className="form-date">
              <button type="button" className="btn-primary" onClick={() => selectDay('W1')}>
                1주일
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('M1')}>
                1개월
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('M3')}>
                3개월
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('M6')}>
                6개월
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('Y1')}>
                1년간
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('99')}>
                초기화
              </button>
            </span>
          </div>
          <div className="row type2">
            <div className="inquiry-wrap full">
              <span className="tit">검색어</span>
              <div className="inquiry-group">
                <input
                  type="text"
                  placeholder="증명서명 또는 발급번호를 입력하세요."
                  className="form-keyword"
                  id="searchWord"
                  name="searchWord"
                  value={searchWord || ''}
                  onChange={({ target }) => setSearchWord(target.value)}
                  onKeyPress={handleKeyPress}
                />
                <button className="btn-search" onClick={(e) => onSelected(e, 'searchWord', searchWord)}>
                  검색
                </button>
              </div>
            </div>
          </div>
        </div>

        <EfDocumentList
          data={props.efdocList?.content}
          orgdata={props.certboxOrgList}
          commoncode={props.commoncode}
          onCertboxDetail={onCertboxDetail}
          onCertboxSubmit={onCertboxSubmit}
          reload={props.readEfDocList}
          onSelected={onSelected}
          pagingInfo={pagingInfo}
          tabId={tabId}
        />

        <div className="list-footer">
          <Pagination pagingInfo={pagingInfo} onChange={(param) => searchList(searchInfo, param - 1)} />
        </div>
      </div>
      {/* //contents */}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    soloSelectInfo: state.efdoc?.selectInfo,
    efdocList: state.efdoc?.efdocList?.list,
    certboxOrgList: state.efdoc?.efdocList?.Alllist,
    commoncode: state.commoncode?.co,
    history: state.efdoc?.history,
  }
}

const actionCreators = {
  changeSearchInfo: efdocActions.changeSearchInfo,
  readEfDocList: efdocActions.readEfDocList,
  settingHistory: efdocActions.settingHistory,
  showModalBagic: modalActions.showModalBagic,
  common: commonActions.getCommonCode,
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(EfDocument)
